import {
  faBold,
  faItalic,
  faStrikethrough,
  faUnderline,
} from '@fortawesome/pro-regular-svg-icons';
import { ToolbarButton, ToolbarButtonIcon } from './components';
import { ToolBarItemProps } from './types';

export const BoldButton = ({
  editor,
  afterCommandExecuted,
}: ToolBarItemProps) => {
  return (
    <ToolbarButton
      $active={editor.isActive('bold')}
      icon={<ToolbarButtonIcon icon={faBold} />}
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => {
        editor.chain().focus().toggleBold().run();
        afterCommandExecuted?.();
      }}
    />
  );
};

export const ItalicButton = ({
  editor,
  afterCommandExecuted,
}: ToolBarItemProps) => {
  return (
    <ToolbarButton
      $active={editor.isActive('italic')}
      icon={<ToolbarButtonIcon icon={faItalic} />}
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => {
        editor.chain().focus().toggleItalic().run();
        afterCommandExecuted?.();
      }}
    />
  );
};

export const UnderlineButton = ({
  editor,
  afterCommandExecuted,
}: ToolBarItemProps) => {
  return (
    <ToolbarButton
      $active={editor.isActive('underline')}
      icon={<ToolbarButtonIcon icon={faUnderline} />}
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => {
        editor.chain().focus().toggleUnderline().run();
        afterCommandExecuted?.();
      }}
    />
  );
};

export const StrikethroughButton = ({
  editor,
  afterCommandExecuted,
}: ToolBarItemProps) => {
  return (
    <ToolbarButton
      $active={editor.isActive('strike')}
      icon={<ToolbarButtonIcon icon={faStrikethrough} />}
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => {
        editor.chain().focus().toggleStrike().run();
        afterCommandExecuted?.();
      }}
    />
  );
};
